<template>
  <v-container id="page-customer-list">
    <div class="page-title">{{ $route.name }}</div>

    <v-row>
      <v-col>
        <v-menu
          v-model="registerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width: 200px; display: inline-block;">
              <v-text-field
                clearable
                v-model="registerDate"
                label="회원가입일"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker
            v-model="registerDate"
            @input="registerMenu = false"
            firstDayOfWeek="1"
            :selectedDate="registerDate"
            locale="ko-kr"
          ></c-date-picker>
        </v-menu>

        <div style="width: 250px; display: inline-block; margin-left: 18px;">
          <v-text-field
            v-model="searchKeyword"
            label="고객명 검색"
            prepend-icon="search"
            maxlength="32"
            @keyup="onSearch"
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn
          color="blue"
          outlined
          iconName="add"
          @click="addCustomerDialog = true"
          :disabled="disabledByRole"
          >회원등록
        </c-btn>
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="delete"
          @click="onDeleteCustomers"
          :disabled="disabledByRole"
          >회원 삭제
        </c-btn>
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="attach_file"
          @click="addCustomerBulkRegistDialog = true"
          :disabled="disabledByRole"
          >일괄등록
        </c-btn>
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="attach_file"
          @click="downloadSample"
          :disabled="disabledByRole"
          >등록 양식
        </c-btn>
        <c-btn
          class="ml-1"
          color="blue"
          outlined
          iconName="file_download"
          @click="downloadExcelDialog = true"
          :disabled="disabledByRole"
          >Excel
        </c-btn>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tab"
      slider-color="blue"
      slider-size="3"
      v-if="menuItems.length > 0"
    >
      <v-tab v-for="menu in menuItems" @click="selectedMenu = menu">
        <span class="font-weight-bold"> {{ menu.title }} </span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="header in tableHeaders">
        <c-table
          :headers="header"
          itemKey="id"
          show-select
          :selected.sync="selected"
          :items="customerList"
          :page="pagination.page"
          :itemsPerPage="pagination.size"
          :totalElements="totalElements"
          @update:tableOptions="updateOption"
        >
          <template #name="{ item }">
            <span class="common-name">{{
              $func.formatCustomerName(item)
            }}</span>
          </template>
          <template #gender="{ item }">
            {{ item.gender }}
          </template>
          <template #activeStatus="{ item }">
            <span :class="customerActiveClass(item.activeStatus)">
              {{ $func.activeStatus(item.activeStatus) }}
            </span>
          </template>
          <template #customerType="{ item }">
            {{ customerType(item) }}
          </template>
          <template #detail="{ item }">
            <c-btn icon iconName="search" @click="onMoveDetail(item)" />
          </template>
          <template #created="{item}">
            {{ $func.dateToString(item.created) }}
          </template>
          <template #birth="{ item }">
            {{ item.birth ? $func.dateToString(item.birth) : "-" }}
          </template>
        </c-table>
      </v-tab-item>
    </v-tabs-items>
    <customer-c-u-dialog
      :open.sync="addCustomerDialog"
      @reqAddCustomer="reqAddCustomer"
    />

    <bulk-data-register-dialog
      :open.sync="addCustomerBulkRegistDialog"
      uploadTarget="고객"
      @fileData="reqBulkRegist"
    />
    <bulk-data-result-dialog
      :open.sync="bulkRegisterResultDialog"
      :resultBulkUploadType="resultBulkUploadType"
      :resultBulkData="resultBulkData"
      @downloadFailedData="downloadFailedData"
    />

    <download-excel-dialog
      :open.sync="downloadExcelDialog"
      @reqDownloadExcel="reqDownloadExcel"
    />
  </v-container>
</template>
<script>
import CustomerCUDialog from "./CustomerCUDialog";
import BulkDataRegisterDialog from "../Common/BulkDataRegisterDialog";
import BulkDataResultDialog from "../Common/BulkDataResultDialog";

import DownloadExcelDialog from "../Common/DownloadExcelDialog";

import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    CustomerCUDialog,
    BulkDataRegisterDialog,
    BulkDataResultDialog,
    DownloadExcelDialog,
  },
  data() {
    return {
      tableHeaders: [
        //FOR M.ON
        [
          {
            text: "이름",
            value: "name",
            align: "center",
            sortable: true,
          },
          {
            text: "생년월일",
            value: "birth",
            align: "center",
            sortable: true,
          },
          {
            text: "성별",
            value: "gender",
            align: "center",
            sortable: true,
          },
          {
            text: "연락처",
            value: "mobileNo",
            align: "center",
            sortable: true,
          },
          {
            text: "회원유형",
            value: "customerType",
            align: "center",
            sortable: true,
            sort: (a, b) =>
              a.configName < b.configName
                ? -1
                : a.configName === b.configName
                ? 0
                : 1,
          },
          {
            text: "가입일",
            value: "created",
            align: "center",
            sortable: true,
          },
          {
            text: "무단 취소 횟수",
            value: "userCancelCnt",
            align: "center",
            sortable: true,
          },
          {
            text: "활성상태",
            value: "activeStatus",
            align: "center",
            sortable: true,
          },
          {
            text: "상세보기",
            value: "detail",
            align: "center",
            sortable: false,
          },
        ],
        //FOR M.OFF
        [
          {
            text: "이름",
            value: "name",
            align: "center",
            sortable: true,
          },
          {
            text: "생년월일",
            value: "birth",
            align: "center",
            sortable: true,
          },
          {
            text: "성별",
            value: "gender",
            align: "center",
            sortable: true,
          },
          {
            text: "회원유형",
            value: "customerType",
            align: "center",
            sortable: true,
            sort: (a, b) =>
              a.configName < b.configName
                ? -1
                : a.configName === b.configName
                ? 0
                : 1,
          },
          {
            text: "가입일",
            value: "created",
            align: "center",
            sortable: true,
          },
          {
            text: "상세보기",
            value: "detail",
            align: "center",
            sortable: false,
          },
        ],
      ],
      excelColumns: [
        { label: "이름", field: "name" },
        { label: "생년월일", field: "birth" },
        { label: "성별", field: "gender" },
        { label: "연락처", field: "mobileNo" },
        { label: "가입일", field: "created" },
      ],
      customerList: [],
      addCustomerDialog: false,

      addCustomerFormData: {
        name: "",
        gender: "",
        active: "Enable",
        address: "",
        birthYear: "",
        birthMonth: "",
        birthDay: "",
        mobileNo: "",
      },
      addCustomerBulkRegistDialog: false,
      selected: [],
      registerMenu: false,
      registerDate: "",
      searchType: "CUSTOMER_NAME",
      searchKeyword: "",
      downloadExcelDialog: false,

      resultBulkData: null,
      resultBulkUploadType: "new",
      bulkRegisterResultDialog: false,
      tab: 0,
      menuItems: [
        { title: "온라인 회원", value: "on" },
        { title: "오프라인 회원", value: "off" },
      ],
      selectedMenu: "",
      pagination: {
        page: 1,
        size: 10,
        sort: "",
      },
      totalElements: 0,
    };
  },
  watch: {
    tab: function() {
      this.reqGetCustomerList();
    },
    registerDate: function() {
      this.reqGetCustomerList();
    },
  },
  computed: {
    disabledByRole() {
      return this.$store.state.userInfo.role === "RM";
    },
    getExcelFilename() {
      return "회원목록_" + this.$func.dateToString(new Date());
    },
  },
  methods: {
    customerType(item) {
      if (item.customerType === null) return "일반";

      const { configName, configValue } = item.customerType;
      if (configValue === "ct_normal" || configValue == "ct_guardian") {
        return configName;
      } else {
        return "교통약자(" + configName + ")";
      }
    },
    customerActiveClass(active) {
      if (active === "Enable") {
        return "active_on";
      } else if (active === "Disable") {
        return "active_off";
      } else {
        return "active_expired";
      }
    },
    onMoveDetail(item) {
      this.$router.push(`/customers/${item.id}`);
    },

    async reqAddCustomer(data) {
      try {
        const res = await this.$api.addCustomer(data);
        this.addCustomerDialog = false;
        this.reqGetCustomerList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqAddCustomer" });
      }
    },
    async reqGetCustomerList() {
      try {
        const registerType = this.tab === 0 ? "on" : "off";
        const params = {
          ...this.pagination,
          searchType: this.searchType,
          searchKeyword: this.searchKeyword,
          created: this.registerDate ? this.registerDate : "",
        };
        const res = await this.$api.getCustomerList(registerType, params);

        this.customerList = res.data.content.map((item, idx) => {
          item.idx = idx;
          item.gender = this.$func.gender(item.gender, false);
          item.created = this.$func.dateToString(item.created);
          item.birth = this.$func.dateToString(item.birth);
          return item;
        });
        this.totalElements = res.data.totalElements;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetCustomerList" });
      }
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqGetCustomerList();
    },
    async reqBulkRegist(data) {
      try {
        const res = await this.$api.customerBulkRegist(data);

        this.resultBulkData = res.data;
        this.resultBulkUploadType = data.get("uploadType");
        this.bulkRegisterResultDialog = true;
        this.reqGetCustomerList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqBulkRegist" });
      }
      this.addCustomerBulkRegistDialog = false;
    },
    async downloadFailedData(fileName) {
      try {
        const response = await this.$api.downloadFiles(fileName);

        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.headers["content-type"] })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "downloadFailedData" });
      }
    },
    async downloadSample() {
      window.location.href = this.$func.getExcelUrl(
        "/회원_일괄_등록_양식_ver20210615.xlsx"
      );
    },
    async onDeleteCustomers() {
      if (this.selected.length < 1) {
        this.$store.commit("alert", {
          open: true,
          msg: "삭제할 회원을 선택해주세요.",
        });
      } else {
        this.$store.commit("alert", {
          open: true,
          msg:
            "예약이 존재하는 회원은 삭제가 불가능합니다.\n예약건이 존재하는 회원을 제외하고 삭제를 원하는 경우 확인 버튼을 눌러주세요.",
          confirm: true,
          persistent: true,
          callBack: () => {
            this.reqDeleteCustomers();
          },
        });
      }
    },
    async reqDeleteCustomers() {
      try {
        const total = this.selected.length;
        const res = await this.$api.deleteCustomers(
          this.selected.map((customer) => customer.id)
        );
        let msg = "";
        if (res.data.length === total) {
          msg = "선택한 모든 회원이 삭제되었습니다.";
        } else {
          msg =
            "선택한 " +
            total +
            " 명의 회원중 " +
            res.data.length +
            " 명이 삭제되었습니다.";
        }
        this.selected = [];
        this.reqGetCustomerList();
        this.$store.commit("snackbar", { timeout: 4000, msg: msg });
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqDeleteCustomers" });
      }
    },
    async reqDownloadExcel() {
      this.downloadExcelDialog = false;
      const filename = "회원목록_" + this.$func.curDateString();
      const response = await this.$api.getCustomerInfoExcel(filename);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqGetCustomerList();
      } else {
        return;
      }
    },
  },
  activated() {
    this.reqGetCustomerList();
  },
};
</script>

<style>
.birth-select {
  width: 50px !important;
  margin: 0 10px !important;
}

.active_on {
  display: inline-block;
  width: 75px;
  padding: 8px 0px;
  border-radius: 4px;
  line-height: 1em;
  color: white;
  background-color: #0096e0 !important;
  border-color: #0096e0 !important;
}

.active_off {
  display: inline-block;
  width: 75px;
  padding: 8px 0px;
  border-radius: 4px;
  line-height: 1em;
  color: white;
  background-color: #bdbdbd !important;
  border-color: #bdbdbd !important;
}
.active_expired {
  display: inline-block;
  width: 75px;
  padding: 8px 0px;
  border-radius: 4px;
  line-height: 1em;
  color: white;
  background-color: #f87979 !important;
  border-color: #bdbdbd !important;
}
</style>
